/**
 * @module app.menu
 */

const Controller = class {
  // FIXME: Turn this into a component with isolated scope
  // FIXME: Replace hard-coded layers in partial by dynamic content generated from layer tree
};

/**
 * @return {!angular.Directive}
 */
const directive = () => {
  return {
    controller: Controller,
    controllerAs: '$ctrl',
    restrict: 'E',
    scope: false,
    templateUrl: 'js/app/menu/menu.html'
  };
};

const name = 'appMenu';
export default angular.module(name, []).directive(name, directive);
